var map = {
	"./ad.svg": "./resources/assets/images/flags/ad.svg",
	"./ae.svg": "./resources/assets/images/flags/ae.svg",
	"./af.svg": "./resources/assets/images/flags/af.svg",
	"./ag.svg": "./resources/assets/images/flags/ag.svg",
	"./ai.svg": "./resources/assets/images/flags/ai.svg",
	"./al.svg": "./resources/assets/images/flags/al.svg",
	"./am.svg": "./resources/assets/images/flags/am.svg",
	"./ao.svg": "./resources/assets/images/flags/ao.svg",
	"./ar.svg": "./resources/assets/images/flags/ar.svg",
	"./as.svg": "./resources/assets/images/flags/as.svg",
	"./at.svg": "./resources/assets/images/flags/at.svg",
	"./au.svg": "./resources/assets/images/flags/au.svg",
	"./aw.svg": "./resources/assets/images/flags/aw.svg",
	"./ax.svg": "./resources/assets/images/flags/ax.svg",
	"./az.svg": "./resources/assets/images/flags/az.svg",
	"./ba.svg": "./resources/assets/images/flags/ba.svg",
	"./bb.svg": "./resources/assets/images/flags/bb.svg",
	"./bd.svg": "./resources/assets/images/flags/bd.svg",
	"./be.svg": "./resources/assets/images/flags/be.svg",
	"./bf.svg": "./resources/assets/images/flags/bf.svg",
	"./bg.svg": "./resources/assets/images/flags/bg.svg",
	"./bh.svg": "./resources/assets/images/flags/bh.svg",
	"./bi.svg": "./resources/assets/images/flags/bi.svg",
	"./bj.svg": "./resources/assets/images/flags/bj.svg",
	"./bl.svg": "./resources/assets/images/flags/bl.svg",
	"./bm.svg": "./resources/assets/images/flags/bm.svg",
	"./bn.svg": "./resources/assets/images/flags/bn.svg",
	"./bo.svg": "./resources/assets/images/flags/bo.svg",
	"./bq-bo.svg": "./resources/assets/images/flags/bq-bo.svg",
	"./bq-sa.svg": "./resources/assets/images/flags/bq-sa.svg",
	"./bq-se.svg": "./resources/assets/images/flags/bq-se.svg",
	"./br.svg": "./resources/assets/images/flags/br.svg",
	"./bs.svg": "./resources/assets/images/flags/bs.svg",
	"./bt.svg": "./resources/assets/images/flags/bt.svg",
	"./bw.svg": "./resources/assets/images/flags/bw.svg",
	"./by.svg": "./resources/assets/images/flags/by.svg",
	"./bz.svg": "./resources/assets/images/flags/bz.svg",
	"./ca-bc.svg": "./resources/assets/images/flags/ca-bc.svg",
	"./ca.svg": "./resources/assets/images/flags/ca.svg",
	"./cc.svg": "./resources/assets/images/flags/cc.svg",
	"./cd.svg": "./resources/assets/images/flags/cd.svg",
	"./cf.svg": "./resources/assets/images/flags/cf.svg",
	"./cg.svg": "./resources/assets/images/flags/cg.svg",
	"./ch.svg": "./resources/assets/images/flags/ch.svg",
	"./ci.svg": "./resources/assets/images/flags/ci.svg",
	"./ck.svg": "./resources/assets/images/flags/ck.svg",
	"./cl.svg": "./resources/assets/images/flags/cl.svg",
	"./cm.svg": "./resources/assets/images/flags/cm.svg",
	"./cn.svg": "./resources/assets/images/flags/cn.svg",
	"./co.svg": "./resources/assets/images/flags/co.svg",
	"./cr.svg": "./resources/assets/images/flags/cr.svg",
	"./cu.svg": "./resources/assets/images/flags/cu.svg",
	"./cv.svg": "./resources/assets/images/flags/cv.svg",
	"./cw.svg": "./resources/assets/images/flags/cw.svg",
	"./cx.svg": "./resources/assets/images/flags/cx.svg",
	"./cy.svg": "./resources/assets/images/flags/cy.svg",
	"./cz.svg": "./resources/assets/images/flags/cz.svg",
	"./de.svg": "./resources/assets/images/flags/de.svg",
	"./dj.svg": "./resources/assets/images/flags/dj.svg",
	"./dk.svg": "./resources/assets/images/flags/dk.svg",
	"./dm.svg": "./resources/assets/images/flags/dm.svg",
	"./do.svg": "./resources/assets/images/flags/do.svg",
	"./dz.svg": "./resources/assets/images/flags/dz.svg",
	"./easter_island.svg": "./resources/assets/images/flags/easter_island.svg",
	"./ec-w.svg": "./resources/assets/images/flags/ec-w.svg",
	"./ec.svg": "./resources/assets/images/flags/ec.svg",
	"./ee.svg": "./resources/assets/images/flags/ee.svg",
	"./eg.svg": "./resources/assets/images/flags/eg.svg",
	"./eh.svg": "./resources/assets/images/flags/eh.svg",
	"./er.svg": "./resources/assets/images/flags/er.svg",
	"./es-ce.svg": "./resources/assets/images/flags/es-ce.svg",
	"./es-cn.svg": "./resources/assets/images/flags/es-cn.svg",
	"./es-ga.svg": "./resources/assets/images/flags/es-ga.svg",
	"./es-ib.svg": "./resources/assets/images/flags/es-ib.svg",
	"./es-ml.svg": "./resources/assets/images/flags/es-ml.svg",
	"./es-pv.svg": "./resources/assets/images/flags/es-pv.svg",
	"./es-variant.svg": "./resources/assets/images/flags/es-variant.svg",
	"./es.svg": "./resources/assets/images/flags/es.svg",
	"./esperanto.svg": "./resources/assets/images/flags/esperanto.svg",
	"./et.svg": "./resources/assets/images/flags/et.svg",
	"./european_union.svg": "./resources/assets/images/flags/european_union.svg",
	"./fi.svg": "./resources/assets/images/flags/fi.svg",
	"./fj.svg": "./resources/assets/images/flags/fj.svg",
	"./fk.svg": "./resources/assets/images/flags/fk.svg",
	"./fm.svg": "./resources/assets/images/flags/fm.svg",
	"./fo.svg": "./resources/assets/images/flags/fo.svg",
	"./fr-h.svg": "./resources/assets/images/flags/fr-h.svg",
	"./fr.svg": "./resources/assets/images/flags/fr.svg",
	"./ga.svg": "./resources/assets/images/flags/ga.svg",
	"./gb-eng.svg": "./resources/assets/images/flags/gb-eng.svg",
	"./gb-ork.svg": "./resources/assets/images/flags/gb-ork.svg",
	"./gb-sct.svg": "./resources/assets/images/flags/gb-sct.svg",
	"./gb-wls.svg": "./resources/assets/images/flags/gb-wls.svg",
	"./gb.svg": "./resources/assets/images/flags/gb.svg",
	"./gd.svg": "./resources/assets/images/flags/gd.svg",
	"./ge-ab.svg": "./resources/assets/images/flags/ge-ab.svg",
	"./ge.svg": "./resources/assets/images/flags/ge.svg",
	"./gf.svg": "./resources/assets/images/flags/gf.svg",
	"./gg.svg": "./resources/assets/images/flags/gg.svg",
	"./gh.svg": "./resources/assets/images/flags/gh.svg",
	"./gi.svg": "./resources/assets/images/flags/gi.svg",
	"./gl.svg": "./resources/assets/images/flags/gl.svg",
	"./gm.svg": "./resources/assets/images/flags/gm.svg",
	"./gn.svg": "./resources/assets/images/flags/gn.svg",
	"./gq.svg": "./resources/assets/images/flags/gq.svg",
	"./gr.svg": "./resources/assets/images/flags/gr.svg",
	"./gt.svg": "./resources/assets/images/flags/gt.svg",
	"./gu.svg": "./resources/assets/images/flags/gu.svg",
	"./gw.svg": "./resources/assets/images/flags/gw.svg",
	"./gy.svg": "./resources/assets/images/flags/gy.svg",
	"./hausa.svg": "./resources/assets/images/flags/hausa.svg",
	"./hk.svg": "./resources/assets/images/flags/hk.svg",
	"./hmong.svg": "./resources/assets/images/flags/hmong.svg",
	"./hn.svg": "./resources/assets/images/flags/hn.svg",
	"./hr.svg": "./resources/assets/images/flags/hr.svg",
	"./ht.svg": "./resources/assets/images/flags/ht.svg",
	"./hu.svg": "./resources/assets/images/flags/hu.svg",
	"./id.svg": "./resources/assets/images/flags/id.svg",
	"./ie.svg": "./resources/assets/images/flags/ie.svg",
	"./il.svg": "./resources/assets/images/flags/il.svg",
	"./im.svg": "./resources/assets/images/flags/im.svg",
	"./in.svg": "./resources/assets/images/flags/in.svg",
	"./io.svg": "./resources/assets/images/flags/io.svg",
	"./iq.svg": "./resources/assets/images/flags/iq.svg",
	"./ir.svg": "./resources/assets/images/flags/ir.svg",
	"./is.svg": "./resources/assets/images/flags/is.svg",
	"./it-82.svg": "./resources/assets/images/flags/it-82.svg",
	"./it-88.svg": "./resources/assets/images/flags/it-88.svg",
	"./it.svg": "./resources/assets/images/flags/it.svg",
	"./je.svg": "./resources/assets/images/flags/je.svg",
	"./jm.svg": "./resources/assets/images/flags/jm.svg",
	"./jo.svg": "./resources/assets/images/flags/jo.svg",
	"./jp.svg": "./resources/assets/images/flags/jp.svg",
	"./kannada.svg": "./resources/assets/images/flags/kannada.svg",
	"./ke.svg": "./resources/assets/images/flags/ke.svg",
	"./kg.svg": "./resources/assets/images/flags/kg.svg",
	"./kh.svg": "./resources/assets/images/flags/kh.svg",
	"./ki.svg": "./resources/assets/images/flags/ki.svg",
	"./km.svg": "./resources/assets/images/flags/km.svg",
	"./kn.svg": "./resources/assets/images/flags/kn.svg",
	"./kp.svg": "./resources/assets/images/flags/kp.svg",
	"./kr.svg": "./resources/assets/images/flags/kr.svg",
	"./kurdistan.svg": "./resources/assets/images/flags/kurdistan.svg",
	"./kw.svg": "./resources/assets/images/flags/kw.svg",
	"./ky.svg": "./resources/assets/images/flags/ky.svg",
	"./kz.svg": "./resources/assets/images/flags/kz.svg",
	"./la.svg": "./resources/assets/images/flags/la.svg",
	"./lb.svg": "./resources/assets/images/flags/lb.svg",
	"./lc.svg": "./resources/assets/images/flags/lc.svg",
	"./li.svg": "./resources/assets/images/flags/li.svg",
	"./lk.svg": "./resources/assets/images/flags/lk.svg",
	"./lr.svg": "./resources/assets/images/flags/lr.svg",
	"./ls.svg": "./resources/assets/images/flags/ls.svg",
	"./lt.svg": "./resources/assets/images/flags/lt.svg",
	"./lu.svg": "./resources/assets/images/flags/lu.svg",
	"./lv.svg": "./resources/assets/images/flags/lv.svg",
	"./ly.svg": "./resources/assets/images/flags/ly.svg",
	"./ma.svg": "./resources/assets/images/flags/ma.svg",
	"./malayali.svg": "./resources/assets/images/flags/malayali.svg",
	"./maori.svg": "./resources/assets/images/flags/maori.svg",
	"./mc.svg": "./resources/assets/images/flags/mc.svg",
	"./md.svg": "./resources/assets/images/flags/md.svg",
	"./me.svg": "./resources/assets/images/flags/me.svg",
	"./mg.svg": "./resources/assets/images/flags/mg.svg",
	"./mh.svg": "./resources/assets/images/flags/mh.svg",
	"./mk.svg": "./resources/assets/images/flags/mk.svg",
	"./ml.svg": "./resources/assets/images/flags/ml.svg",
	"./mm.svg": "./resources/assets/images/flags/mm.svg",
	"./mn.svg": "./resources/assets/images/flags/mn.svg",
	"./mo.svg": "./resources/assets/images/flags/mo.svg",
	"./mp.svg": "./resources/assets/images/flags/mp.svg",
	"./mq.svg": "./resources/assets/images/flags/mq.svg",
	"./mr.svg": "./resources/assets/images/flags/mr.svg",
	"./ms.svg": "./resources/assets/images/flags/ms.svg",
	"./mt.svg": "./resources/assets/images/flags/mt.svg",
	"./mu.svg": "./resources/assets/images/flags/mu.svg",
	"./mv.svg": "./resources/assets/images/flags/mv.svg",
	"./mw.svg": "./resources/assets/images/flags/mw.svg",
	"./mx.svg": "./resources/assets/images/flags/mx.svg",
	"./my.svg": "./resources/assets/images/flags/my.svg",
	"./mz.svg": "./resources/assets/images/flags/mz.svg",
	"./na.svg": "./resources/assets/images/flags/na.svg",
	"./nato.svg": "./resources/assets/images/flags/nato.svg",
	"./nc.svg": "./resources/assets/images/flags/nc.svg",
	"./ne.svg": "./resources/assets/images/flags/ne.svg",
	"./nf.svg": "./resources/assets/images/flags/nf.svg",
	"./ng.svg": "./resources/assets/images/flags/ng.svg",
	"./ni.svg": "./resources/assets/images/flags/ni.svg",
	"./nl.svg": "./resources/assets/images/flags/nl.svg",
	"./no.svg": "./resources/assets/images/flags/no.svg",
	"./northern_cyprus.svg": "./resources/assets/images/flags/northern_cyprus.svg",
	"./np.svg": "./resources/assets/images/flags/np.svg",
	"./nr.svg": "./resources/assets/images/flags/nr.svg",
	"./nu.svg": "./resources/assets/images/flags/nu.svg",
	"./nz.svg": "./resources/assets/images/flags/nz.svg",
	"./om.svg": "./resources/assets/images/flags/om.svg",
	"./pa.svg": "./resources/assets/images/flags/pa.svg",
	"./pe.svg": "./resources/assets/images/flags/pe.svg",
	"./pf.svg": "./resources/assets/images/flags/pf.svg",
	"./pg.svg": "./resources/assets/images/flags/pg.svg",
	"./ph.svg": "./resources/assets/images/flags/ph.svg",
	"./pk.svg": "./resources/assets/images/flags/pk.svg",
	"./pl.svg": "./resources/assets/images/flags/pl.svg",
	"./pn.svg": "./resources/assets/images/flags/pn.svg",
	"./pr.svg": "./resources/assets/images/flags/pr.svg",
	"./ps.svg": "./resources/assets/images/flags/ps.svg",
	"./pt-20.svg": "./resources/assets/images/flags/pt-20.svg",
	"./pt-30.svg": "./resources/assets/images/flags/pt-30.svg",
	"./pt.svg": "./resources/assets/images/flags/pt.svg",
	"./pw.svg": "./resources/assets/images/flags/pw.svg",
	"./py.svg": "./resources/assets/images/flags/py.svg",
	"./qa.svg": "./resources/assets/images/flags/qa.svg",
	"./ro.svg": "./resources/assets/images/flags/ro.svg",
	"./rs.svg": "./resources/assets/images/flags/rs.svg",
	"./ru.svg": "./resources/assets/images/flags/ru.svg",
	"./rw.svg": "./resources/assets/images/flags/rw.svg",
	"./sa.svg": "./resources/assets/images/flags/sa.svg",
	"./sb.svg": "./resources/assets/images/flags/sb.svg",
	"./sc.svg": "./resources/assets/images/flags/sc.svg",
	"./sd.svg": "./resources/assets/images/flags/sd.svg",
	"./se.svg": "./resources/assets/images/flags/se.svg",
	"./sg.svg": "./resources/assets/images/flags/sg.svg",
	"./si.svg": "./resources/assets/images/flags/si.svg",
	"./sindh.svg": "./resources/assets/images/flags/sindh.svg",
	"./sk.svg": "./resources/assets/images/flags/sk.svg",
	"./sl.svg": "./resources/assets/images/flags/sl.svg",
	"./sm.svg": "./resources/assets/images/flags/sm.svg",
	"./sn.svg": "./resources/assets/images/flags/sn.svg",
	"./so.svg": "./resources/assets/images/flags/so.svg",
	"./somaliland.svg": "./resources/assets/images/flags/somaliland.svg",
	"./south_ossetia.svg": "./resources/assets/images/flags/south_ossetia.svg",
	"./sr.svg": "./resources/assets/images/flags/sr.svg",
	"./ss.svg": "./resources/assets/images/flags/ss.svg",
	"./st.svg": "./resources/assets/images/flags/st.svg",
	"./sv.svg": "./resources/assets/images/flags/sv.svg",
	"./sx.svg": "./resources/assets/images/flags/sx.svg",
	"./sy.svg": "./resources/assets/images/flags/sy.svg",
	"./sz.svg": "./resources/assets/images/flags/sz.svg",
	"./tc.svg": "./resources/assets/images/flags/tc.svg",
	"./td.svg": "./resources/assets/images/flags/td.svg",
	"./tg.svg": "./resources/assets/images/flags/tg.svg",
	"./th.svg": "./resources/assets/images/flags/th.svg",
	"./tibet.svg": "./resources/assets/images/flags/tibet.svg",
	"./tj.svg": "./resources/assets/images/flags/tj.svg",
	"./tk.svg": "./resources/assets/images/flags/tk.svg",
	"./tl.svg": "./resources/assets/images/flags/tl.svg",
	"./tm.svg": "./resources/assets/images/flags/tm.svg",
	"./tn.svg": "./resources/assets/images/flags/tn.svg",
	"./to.svg": "./resources/assets/images/flags/to.svg",
	"./tr.svg": "./resources/assets/images/flags/tr.svg",
	"./transnistria.svg": "./resources/assets/images/flags/transnistria.svg",
	"./tt.svg": "./resources/assets/images/flags/tt.svg",
	"./tv.svg": "./resources/assets/images/flags/tv.svg",
	"./tw.svg": "./resources/assets/images/flags/tw.svg",
	"./tz.svg": "./resources/assets/images/flags/tz.svg",
	"./ua.svg": "./resources/assets/images/flags/ua.svg",
	"./ug.svg": "./resources/assets/images/flags/ug.svg",
	"./united_nations.svg": "./resources/assets/images/flags/united_nations.svg",
	"./us-hi.svg": "./resources/assets/images/flags/us-hi.svg",
	"./us.svg": "./resources/assets/images/flags/us.svg",
	"./uy.svg": "./resources/assets/images/flags/uy.svg",
	"./uz.svg": "./resources/assets/images/flags/uz.svg",
	"./va.svg": "./resources/assets/images/flags/va.svg",
	"./vc.svg": "./resources/assets/images/flags/vc.svg",
	"./ve.svg": "./resources/assets/images/flags/ve.svg",
	"./vg.svg": "./resources/assets/images/flags/vg.svg",
	"./vi.svg": "./resources/assets/images/flags/vi.svg",
	"./vn.svg": "./resources/assets/images/flags/vn.svg",
	"./vu.svg": "./resources/assets/images/flags/vu.svg",
	"./ws.svg": "./resources/assets/images/flags/ws.svg",
	"./xk.svg": "./resources/assets/images/flags/xk.svg",
	"./ye.svg": "./resources/assets/images/flags/ye.svg",
	"./yiddish.svg": "./resources/assets/images/flags/yiddish.svg",
	"./za.svg": "./resources/assets/images/flags/za.svg",
	"./zm.svg": "./resources/assets/images/flags/zm.svg",
	"./zw.svg": "./resources/assets/images/flags/zw.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/assets/images/flags sync \\.(png|jpe?g|svg)$";